<template>
    <div class="wrapper">

        <!-- Loading Window --->
        <div v-if="isLoading == true" class="loading-screen bg-white">
            <div class="message">
                <b-icon icon="arrow-clockwise" animation="spin" /> {{ $t('general.loadingApp') }}
            </div>
        </div>

        <div v-if="$store.state.savingData" class="busy-state bg-white shadow"><b-icon icon="three-dots" animation="cylon" class="mr-3 color-blue"></b-icon> {{ $t('general.working') }}</div>

        <!-- Sidemenu --->
        <div class="btnShowSidebar shadow-sm" :class="{btnOffScreen:  ShowSidebar}" @click="SidebarToggle">
            <b-icon-list />
        </div>
        <nav class="sidebar bg-white" :class="{SidebarOffScreen: !ShowSidebar}">
            <div v-if="typeof $store.state.config.user != 'undefined'" class=" user small d-block"> <b-icon-person-circle class="d-inline-block" /> {{$store.state.config.user.email}}</div>
            <div class="text-right p-2 border-bottom">
                <div @click="SidebarToggle" class="curser-pointer"><span class="btnHideSidebar">{{ $t('general.close') }}</span>  <b-icon-x-circle-fill class="color-red" /></div>
            </div>
            <PrivateMenu></PrivateMenu>
        </nav>

        <!-- Account configuration-->

        <!--<p>(This is the LAA container that displays components depending on the chose route via router.js)</p>-->
        <div id="content" :class="{SidebarSpacing: ShowSidebar}">

            <!-- Inventory Limit warning -->
            <div v-if="isLoading == false">
                <div v-if="$store.state.lstAllAprons.length >= $store.state.config.hospitalPreferences.hospital.apronLimit &&  $store.state.config.hospitalPreferences.hospital.apronLimit != 0"
                     class="message-with-icon-cta bg-white border-red mt-4 mr-4 ml-4">
                    <div class="message-wrapper ">
                        <b-icon-exclamation-circle-fill class="color-red large-text" />
                        <p> {{ $t('accountConfig.itemLimitReached',   ['(' + $store.state.config.hospitalPreferences.hospital.apronLimit + ')'])  }}</p>
                    </div>
                    <button onclick="location.href='mailto:sales@cablon.nl?subject=My inventory is full';" class="medium-button blue-gradient">{{ $t('contact.contactUs') }}</button>
                </div>
            </div>

            <router-view v-if="isLoading == false"></router-view>
        </div>
    </div>
</template>

<script src="../../scripts/General.js"></script>

<script>
    // @ is an alias to /src
    import PrivateMenu from '@/private/components/PrivateMenu.vue'
    import { beforeUnloadListener } from '@/scripts/General.js'
    import AccountConfig from '@/private/components/AccountConfig.vue'
    import Bus from '@/Bus.js';

    export default {
        name: 'LAA',
        data() {
            return {
                ShowSidebar: true,
                //showStartModal: Boolean,
            }
        },
        components: {
            PrivateMenu,
            AccountConfig
        },
        beforeMount: function () {
           

        },
        methods: {
            //togle sidebar on user input
            SidebarToggle: function () {
                this.ShowSidebar = !this.ShowSidebar;
            },

            onResize() {
                //set ismobile on true on smaller screen
                if (this.ShowSidebar == true) {
                    this.ShowSidebar = window.innerWidth >= 768
                }

            },
            async openStartModal() {
                await this.$store.dispatch('GET_CommonData')

                if (this.$store.state.config.hospitalPreferences.showStartModal === true) {
                    Bus.$emit('set-modal-data', '', AccountConfig, this.$t('dashboardHome.accountConfig'), undefined, undefined, false);

                    Bus.$emit('open-modal');
                }
            },
            

        },
        beforeMount() {
            //Get common data before mounting HTML, to avoid undefined errors in vue HTML
            this.$store.dispatch('GET_CommonData')
        },
        mounted() {
            //fire Resize event
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
            this.openStartModal();
            
        },
        computed: {
            isLoading() {
                return this.$store.state.blnAppLoading;
            }
        },
        watch: {
            $route(to, from) {

                if (window.innerWidth <= 768 && this.ShowSidebar == true) {
                    this.ShowSidebar = false;
                }
                removeEventListener("beforeunload", beforeUnloadListener, { capture: true });
            }
        }
    }
</script>
